/**
 * @description Module recherche de l'en-tête
 */

/* global bsBreakpoints */

(() => {
	// VARS
	const root = document.querySelector('[data-js-header-search-root]');
	const toggleBtn = document.querySelector('[data-js-header-search-toggle]');
	const content = root.querySelector('[data-drupal-selector="edit-text"]');
	const searchBtn =
		document.querySelector(
			'[data-drupal-selector="edit-submit-main-search-engine"]'
		) || null;
	const searchBtn2 =
		document.querySelector(
			'[data-drupal-selector="edit-submit-main-search-engine-2"]'
		) || null; // button après recherche dans moteur de recherche
	root.insertAdjacentHTML('beforeend', '<div class="search-overlay"></div>');
	const searchOverlay = document.querySelector('.search-overlay');

	// FONCTIONS

	const addIcon = () => {
		if (searchBtn2) {
			searchBtn2.setAttribute('data-icon', 'search');
		}
	};

	const toggle = () => {
		const underMedium =
			bsBreakpoints.detectBreakpoint() === 'xSmall' ||
			bsBreakpoints.detectBreakpoint() === 'small' ||
			bsBreakpoints.detectBreakpoint() === 'medium';

		toggleBtn.addEventListener('click', () => {
			if (toggleBtn.getAttribute('data-icon') === 'search') {
				content.style.display = 'block';
				if (searchBtn) {
					searchBtn.style.display = 'block';
				}

				if (searchBtn2) {
					searchBtn2.style.display = 'block';
				}

				if (underMedium) {
					toggleBtn.setAttribute('data-icon', 'cross');
					toggleBtn.setAttribute('aria-expanded', true);
					searchOverlay.style.display = 'block';
				} else {
					toggleBtn.style.display = 'none';
				}
			} else {
				toggleBtn.setAttribute('data-icon', 'search');
				toggleBtn.setAttribute('aria-expanded', false);
				content.style.display = 'none';
				searchOverlay.style.display = 'none';
				if (searchBtn) {
					searchBtn.style.display = 'none';
				}
				if (searchBtn2) {
					searchBtn2.style.display = 'none';
				}
			}
		});
	};

	// GO 🚀
	const init = () => {
		if (document.body.contains(root)) {
			addIcon();
			toggle();
		}
	};

	init();
})();
